import {
    CreateQuitusPayload,
    ecsApi,
    EcsApiResponse,
    GetQuitusContentPayload,
    GetQuitusContentResponse,
    GetQuitusesResponse,
    GetQuitusTypesResponse
} from '@services';

export const quitusApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        getQuituses: builder.mutation<GetQuitusesResponse, void>({
            query: () => ({
                url: '/quitus',
                method: 'GET'
            })
        }),
        getQuitusContent: builder.mutation<GetQuitusContentResponse, GetQuitusContentPayload>({
            query: ({ quitusId }) => ({
                url: `/quitus/content?id_quitus=${quitusId}`,
                method: 'GET'
            })
        }),
        getQuitusTypes: builder.mutation<GetQuitusTypesResponse, void>({
            query: () => ({
                url: '/quitus/types',
                method: 'GET'
            })
        }),
        createQuitus: builder.mutation<EcsApiResponse<void>, CreateQuitusPayload>({
            query: (payload) => ({
                url: '/quitus',
                method: 'POST',
                body: payload
            })
        })
    })
});

export const { useGetQuitusesMutation, useGetQuitusContentMutation, useGetQuitusTypesMutation, useCreateQuitusMutation } = quitusApi;
